export const YUSA_ASSOCIATION_LIST_SUCCESS = 'YUSA_ASSOCIATION_LIST_SUCCESS';
export const YUSA_ASSOCIATION_LIST_FAILURE = 'YUSA_ASSOCIATION_LIST_FAILURE';

export const YUSA_YEAR_LIST_SUCCESS = 'YUSA_YEAR_LIST_SUCCESS';
export const YUSA_YEAR_LIST_FAILURE = 'YUSA_YEAR_LIST_FAILURE';
